var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTick = function SvgTick(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 14",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88387 12.72L0.841974 8.24915L2.81836 5.99219L6.86025 10.463L4.88387 12.72Z",
    fill: "#28DB24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8553 3.87018L4.91086 12.5818L2.78711 10.4629L9.73153 1.7513L11.8553 3.87018Z",
    fill: "#28DB24"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljg4Mzg3IDEyLjcyTDAuODQxOTc0IDguMjQ5MTVMMi44MTgzNiA1Ljk5MjE5TDYuODYwMjUgMTAuNDYzTDQuODgzODcgMTIuNzJaIiBmaWxsPSIjMjhEQjI0Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuODU1MyAzLjg3MDE4TDQuOTEwODYgMTIuNTgxOEwyLjc4NzExIDEwLjQ2MjlMOS43MzE1MyAxLjc1MTNMMTEuODU1MyAzLjg3MDE4WiIgZmlsbD0iIzI4REIyNCIvPgo8L3N2Zz4K";